import React, { useEffect, useState } from "react";
import "./ProgramSetup.css";
import UploadFile from "./UploadFile";
import { IAMAxios } from "../../../../API";
import { Button, Modal, Form } from "react-bootstrap";
import DataTable from "../DataTable/DataTable";
const ProgramSetup = () => {

    const [usersList, setUsersList] = useState([]);
    const [userId, setUserId] = useState();
    const [userFirstName, setUserFirstName] = useState();
    const [userLastName, setUserLastName] = useState();
    const [userEmail, setUserEmail] = useState();
    const [userIndustry, setUserIndustry] = useState();
    const [userGeography, setUserGeography] = useState();
    const [userLocation, setUserLocation] = useState();
    const [userOffering, setUserOffering] = useState();
    const [userPortfolio, setUserPortfolio] = useState();
    const [userJobLevel, setUserJobLevel] = useState();
    const [tableData, setTableData] = React.useState({});
    const [filters, setFilters] = React.useState({});
    


    const [showEditUser, setShowEditUser] = useState(false);

    useEffect(() => {
        getSAPUsers();
    }, []);

    useEffect(() => {
        generateTableData();
    }, [usersList]);

    const getSAPUsers = () => {
        IAMAxios.get("/SAPUser/getsapusers")
            .then(function (response) {
                setUsersList(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const generateTableData = () => {

        // let roles = usersList.map((x) => {
        //     let label = roleLabels[x.role];
        //     return { value: x.role, label: label };
        // });
        // const ids = roles.map(o => o.value);
        // roles = roles.filter(({ value }, index) => !ids.includes(value, index + 1));

        let columns = [
            {
                label: "First Name",
                field: 'firstName',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'First Name',
                    className: 'text-center',
                },
                sort: true,
                filter: true,
                filterType: 'text',
            },
            {
                label: "Last Name",
                field: 'lastName',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Last Name',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Email",
                field: 'email',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Email',
                },
                sort: true,
                filter: true,
                filterType: 'text',
            },
            {
                label: "Offering",
                field: 'offering',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Offering',
                },
                sort: true,
                filter: true,                
                filterType: 'text',

            },
            {
                label: "Portfolio",
                field: 'portfolio',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Portfolio',
                },
                sort: true,
                filter: true,
                filterType: 'text',
            },
            {
                label: "Industry",
                field: 'industry',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Industry',
                },
                sort: true,
                filter: true,
                filterType: 'text',
            },
            {
                label: "Geography",
                field: 'geography',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Geography',
                    'className': 'text-center',
                },
                sort: true,
                filter: true,
                filterType: 'text',
            },
            {
                label: "Location",
                field: 'location',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Location',
                },
                sort: true,
                filter: true,
                filterType: 'text',
            },
            {
                label: "Job Level",
                field: 'jobLevel',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Job Level',
                },
                sort: true,
                filter: true,
                filterType: 'text',
            },

            {
                label: "Action",
                field: 'action',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action',
                }
            },

        ];
        let rows = [];
        usersList.forEach((user) => {
            let row = {};           

            row.id = { value: user.id, label: user.id, export: user.id };
            row.firstName = { value: user.firstName, label: user.firstName, export: user.firstName };
            row.lastName = { value: user.lastName, label: user.lastName, export: user.lastName };
            row.email = { value: user.email, label: user.email, export: user.email };
            row.offering = { value: user.offering, label: user.offering, export: user.offering };
            row.portfolio = { value: user.portfolio, label: user.portfolio, export: user.portfolio };
            row.industry = { value: user.industry, label: user.industry, export: user.industry };
            row.geography = { value: user.geography, label: user.geography, export: user.geography };
            row.location = { value: user.location, label: user.location, export: user.location };
            row.jobLevel = { value: user.jobLevel, label: user.jobLevel, export: user.jobLevel };
            row.action = { value: "", label: <Button className="btn-text" variant="link" onClick={() => editSAPUser(user)}>Edit</Button> };
            rows.push(row);
        });

        setTableData({ columns, rows });
    };


    const editSAPUser = (user) => {
        setUserId(user.id);
        setUserFirstName(user.firstName);
        setUserLastName(user.lastName);
        setUserEmail(user.email);
        setUserIndustry(user.industry);
        setUserGeography(user.geography);
        setUserLocation(user.location);
        setUserOffering(user.offering);
        setUserPortfolio(user.portfolio);
        setUserJobLevel(user.jobLevel);
        setShowEditUser(true);
    };

    const saveUser = () => {
        let data = [{
            "id": userId,
            "firstName": userFirstName,
            "lastName": userLastName,
            "email": userEmail,
            "industry": userIndustry,
            "geography": userGeography,
            "location": userLocation,
            "offering": userOffering,
            "portfolio": userPortfolio,
            "jobLevel": userJobLevel
        }];


        IAMAxios.put("/SAPUser/updatesapusers", data)
            .then(function () {
                getSAPUsers();
                setShowEditUser(false);
            })
            .catch(function (error) {
                console.log(error);
                setShowEditUser(false);
            });
    };


    return (
        <>
            <div className="page-header">
                <h2>SAP Users</h2>
                <UploadFile />
            </div>            
             <div className="data-table">
                <DataTable {...tableData} setFilters={setFilters} filters={filters} />
            </div>           
            <Modal show={showEditUser}
                dialogClassName="upload-modal"
                centered>
                <Form >
                    <Modal.Header>
                        <Modal.Title>Update User</Modal.Title>

                        <div className="close" onClick={() => setShowEditUser(false)}>
                            <span aria-hidden="true">&times;</span>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-2 user-form">
                            <Form.Group className="mb-3  d-flex">
                                <Form.Label className="width-35">First Name</Form.Label>
                                <Form.Control className="width-65" type="text" placeholder="Enter first name" value={userFirstName} onChange={(e) => setUserFirstName(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3  d-flex" >
                                <Form.Label className="width-35">Last Name</Form.Label>
                                <Form.Control className="width-65" type="text" placeholder="Enter last name" value={userLastName} onChange={(e) => setUserLastName(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3  d-flex" >
                                <Form.Label className="width-35">Email</Form.Label>
                                <Form.Control className="width-65" type="email" placeholder="Enter email" value={userEmail} onChange={(e) => setUserEmail(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3  d-flex" >
                                <Form.Label className="width-35">Offering</Form.Label>
                                <Form.Control className="width-65" type="text" placeholder="Enter offering" value={userOffering} onChange={(e) => setUserOffering(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3  d-flex" >
                                <Form.Label className="width-35">Portfolio</Form.Label>
                                <Form.Control className="width-65" type="text" placeholder="Enter portfolio" value={userPortfolio} onChange={(e) => setUserPortfolio(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3  d-flex" >
                                <Form.Label className="width-35">Industry</Form.Label>
                                <Form.Control className="width-65" type="text" placeholder="Enter industry" value={userIndustry} onChange={(e) => setUserIndustry(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3  d-flex" >
                                <Form.Label className="width-35">Geography</Form.Label>
                                <Form.Control className="width-65" type="text" placeholder="Enter geography" value={userGeography} onChange={(e) => setUserGeography(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3  d-flex" >
                                <Form.Label className="width-35">Location</Form.Label>
                                <Form.Control className="width-65" type="text" placeholder="Enter location" value={userLocation} onChange={(e) => setUserLocation(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3  d-flex" >
                                <Form.Label className="width-35">Job Level</Form.Label>
                                <Form.Control className="width-65" type="text" placeholder="Enter job level " value={userJobLevel} onChange={(e) => setUserJobLevel(e.target.value)} />
                            </Form.Group>


                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="btn-text"
                            variant="link"
                            onClick={() => setShowEditUser(false)}
                        >
                            Close
                        </Button>
                        <Button variant="primary" onClick={saveUser}>
                            Save
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
};

export default ProgramSetup;
